<template>
  <leave-utilization-report type="My Staff Leave Utilization Report">
  </leave-utilization-report>
</template>

<script>
import LeaveUtilizationReport from "./LeaveUtilizationReport.vue";
export default {
  components: {
    LeaveUtilizationReport,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/LeaveUtilizationReport/MyStaffLeaveUtilizationReport.vue